import { useState } from "react"

function NewChat({ onIniciar, onCerrar }) {
  const [toUserId, setToUserId] = useState("")
  const [nombreContacto, setNombreContacto] = useState("")
  const [error, setError] = useState("")

  const handleIniciar = () => {
    const id = toUserId.trim().toUpperCase()
    if (!id) {
      setError("Introduce el ID del contacto")
      return
    }
    if (!id.startsWith("PM-") || id.length < 6) {
      setError("El ID debe tener el formato PM-XXXX")
      return
    }
    onIniciar(id, nombreContacto.trim())
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleIniciar()
    if (e.key === "Escape") onCerrar()
  }

  return (
    <div className="modal-overlay" onClick={onCerrar}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Nueva conversación</h3>
          <button className="modal-close" onClick={onCerrar}>✕</button>
        </div>
        <p className="modal-desc">
          Pide a tu contacto que comparta su ID anónimo desde su perfil.
        </p>
        <div className="form-group">
          <label>ID del contacto</label>
          <input
            placeholder="PM-XXXX"
            value={toUserId}
            onChange={e => { setToUserId(e.target.value); setError("") }}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </div>
        <div className="form-group">
          <label>Nombre <span className="label-optional">(opcional)</span></label>
          <input
            placeholder="¿Cómo quieres llamarle?"
            value={nombreContacto}
            onChange={e => setNombreContacto(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="modal-buttons">
          <button className="btn-secondary" onClick={onCerrar}>Cancelar</button>
          <button className="btn-primary" onClick={handleIniciar}>Iniciar chat</button>
        </div>
      </div>
    </div>
  )
}

export default NewChat
